import React, { useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';
import PropTypes from 'prop-types';

const IconEdit = ({
    size = 50,
    disabled = false,
    onClick,
    style,
    fill,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 50 50'
            fill={disabled ? '#cccccc' : ''}
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...buildSvgEvents(ref, disabled, onClick, fill)}
            {...props}
        >
            <g strokeWidth={0.586}>
                <path d='M19.748 23.672c-3.916 3.59-5.277 7.864-5.958 12.993 3.064-1.026 6.81-1.026 8.852-2.906 7.49-6.838 14.3-14.19 21.45-21.37l-6.639-6.667c-5.958 5.983-11.576 12.309-17.705 17.95zM49.88 3.67C49.54 1.79 48.179.422 46.136.08c-2.894-.513-4.426 1.539-5.958 3.248 2.043 2.223 4.086 4.274 6.299 6.497 1.702-1.71 4.086-3.248 3.405-6.155z' />
                <path d='M39.496 20.595v25.473H4.086v-35.73H28.6c.51-1.026 1.191-2.052 1.872-3.078.17-.342.34-.513.34-.854 0 0 0-.171.171-.171H0V50h43.582V17.689c-1.192 1.197-2.554 2.222-4.086 2.906z' />
            </g>
        </svg>
    );
};

IconEdit.defaultProps = {
    disabled: false,
    size: 50
};

IconEdit.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.any,
    style: PropTypes.object
};

export default IconEdit;
